export default "<app-menu></app-menu>\r\n  <router-outlet></router-outlet>\r\n  <app-footer></app-footer>";